import independentSamplings from "./independentSamplings";
import violations from "./violations";
import irregularApplications from "./irregularApplications";

const irregularApplicationService = [
    {
        matcher: 'irregularApplication/independentSamplings',
        reply: config => {
            return [200, independentSamplings];
        }
    },
    {
        matcher: /irregularApplication\/independentSamplings\/(.*)/,
        reply: config => {
            const uuid = /irregularApplication\/independentSamplings\/(.*)/.exec(config.url)[1];
            const independentSampling = independentSamplings.find(independentSampling => independentSampling.uuid === uuid);
            return [200, independentSampling];
        }
    },
    {
        matcher: 'irregularApplication/violations',
        reply: config => {
            return [200, violations];
        }
    },
    {
        matcher: /irregularApplication\/violations\/(.*)/,
        reply: config => {
            const id = /irregularApplication\/violations\/(.*)/.exec(config.url)[1];
            const data = violations.find(item => item.uuid === id);
            return [200, data];
        }
    },
    {
        matcher: 'irregularApplication/irregularApplications',
        reply: config => {
            return [200, irregularApplications];
        }
    },
    {
        matcher: /irregularApplication\/irregularApplications\/(.*)/,
        reply: config => {
            const id = /irregularApplication\/irregularApplications\/(.*)/.exec(config.url)[1];
            const data = irregularApplications.find(item => item.uuid === id);
            return [200, data];
        }
    },
]

export default irregularApplicationService;